// extracted by mini-css-extract-plugin
export var borderRadius = "_6j-4";
export var large = "_6j-3";
export var logoContainer = "_6j-0";
export var nameLogo = "_6j-2";
export var small = "_6j-1";